import { assertIsDefined } from '@sgme/fp';
import { FieldMetadataContext } from 'components/common-form/contexts/FieldMetadataContext';
import type { FieldMetadata } from 'models/forms/fields/FieldMetadata';
import { useContext } from 'react';

export function useFieldMetadata<T extends FieldMetadata = FieldMetadata>(fieldId: string): Readonly<T> {
  const metadataById = useContext(FieldMetadataContext);
  assertIsDefined(metadataById, 'can not find context associated to field metadata');
  return metadataById[fieldId] as Readonly<T>;
}
